import React, { useContext } from 'react';
import { cssMap } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { useHeightRef } from '../hooks/useHeightRef.ts';
import { PageCardContext } from '../PageCardContext.ts';
import { PageCardsContext } from '../PageCardsContext.ts';

const EXCERPT_LINE_HEIGHT = 14;
const DEFAULT_NUMBER_OF_LINES = 3;

const styles = cssMap({
	container: {
		flex: '2 0 auto',
		wordWrap: 'break-word',
		marginTop: token('space.200'),
		font: token('font.body.small'),
	},
	text: {
		display: '-webkit-box',
		overflow: 'hidden',
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical',
	},
});

export const Excerpt = () => {
	const { width } = useContext(PageCardsContext);
	const { id, excerpt } = useContext(PageCardContext);

	const DEFAULT_EXCERPT_HEIGHT = EXCERPT_LINE_HEIGHT * DEFAULT_NUMBER_OF_LINES;

	const { ref: outerExcerptRef } = useHeightRef(DEFAULT_EXCERPT_HEIGHT);

	return excerpt ? (
		<div css={styles.container} key={`${id}-${width}`} ref={outerExcerptRef}>
			<div css={styles.text}>{excerpt}</div>
		</div>
	) : null;
};
